import React, { useCallback } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(1)
  },
  title: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.spacing(2.5),
    lineHeight: 1.6,
    fontFamily: theme.typography.h6.fontFamily
  },
  content: {
    color: theme.palette.text.secondary
  },
  actions: {
    padding: theme.spacing(1.5)
  }
}));

type CancelSplitDialogProps = {
  open: boolean;
  cancelSplit: () => void;
  closeHandler: () => void;
};

export const CancelSplitDialog: React.FC<CancelSplitDialogProps> = ({
  cancelSplit,
  open,
  closeHandler
}: CancelSplitDialogProps) => {
  const classes = useStyles();
  const onYesClick = useCallback(
    (e) => {
      e.stopPropagation();
      cancelSplit();
      closeHandler();
    },
    [closeHandler, cancelSplit]
  );

  const onCancelClick = useCallback(
    (e) => {
      e.stopPropagation();
      closeHandler();
    },
    [closeHandler]
  );

  return (
    <Dialog
      open={open}
      className={classes.dialog}
      data-testid="split-cancel-confirmation-dialog"
    >
      <DialogTitle className={classes.title}>
        <FormattedMessage id="note.split.cancelTitle" />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText>
          <FormattedMessage id="note.split.cancelMessage1" />
        </DialogContentText>
        <DialogContentText>
          <FormattedMessage id="note.split.cancelMessage2" />
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onYesClick}
          data-testid="split-cancel-confirmation-dialog-yes"
          color="secondary"
        >
          <FormattedMessage id="note.split.cancelYes" />
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onCancelClick}
          data-testid="split-cancel-confirmation-dialog-cancel"
        >
          <FormattedMessage id="note.split.cancelNo" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
